// The v3 payment_plans API replaces the v1 scheduled_payments_rules one, but its entity differs:
// amounts are numbers rather than decimal strings, next_payment_time is next_payment_date, and the
// payment method is flat instead of nested. Callers keep consuming the v1 shape, so the v3 payload
// is translated here.
//
// TODO: (VCITA2-15351 - rollout.payments.payables_linked_payment_plans cleanup): once the flag is
// released to all users, delete this util and read the v3 field names at the call sites instead.
// The side pane can then hold the numeric amount and format it with Intl, rather than the v1
// decimal string toDecimalString reproduces here for compatibility.
// vue/src/modules/payments/utils/paymentPlanUtil.js carries the same conversion for the vue app -
// the two have no shared layer to live in, so fix and delete them together.

/**
 * v1 served amounts as decimal strings ("50.0", "12.25") and the side pane interpolates them
 * straight into labels and multiplies them, so a whole number has to keep its trailing ".0".
 *
 * @param {number} amount
 * @returns {string}
 */
const toDecimalString = (amount) => (Number.isInteger(amount) ? amount.toFixed(1) : String(amount));

/**
 * Translates a v3 payment plan into the v1 scheduled_payments_rule shape the store and side pane
 * consume.
 *
 * Only amount_paid defaults: the v3 entity marks amount required and amount_paid optional. A
 * missing amount means something upstream is broken, and "$0.0" would hide that behind a number a
 * user could act on.
 *
 * @param {{uid: string, amount: number, amount_paid: (number|undefined),
 *          next_payment_date: ?string, payment_method_type: string,
 *          payment_method_uid: string}} plan
 * @returns {{uid: string, amount: string, amount_paid: string, next_payment_time: ?string,
 *            payment_method: {type: string, uid: string}}}
 */
export default function toScheduledPaymentsRule({
  amount,
  amount_paid: amountPaid,
  next_payment_date: nextPaymentDate,
  payment_method_type: paymentMethodType,
  payment_method_uid: paymentMethodUid,
  ...plan
}) {
  return {
    ...plan,
    amount: toDecimalString(amount),
    amount_paid: toDecimalString(amountPaid ?? 0),
    next_payment_time: nextPaymentDate,
    payment_method: { type: paymentMethodType, uid: paymentMethodUid },
  };
}
